import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLight: localStorage.getItem('theme') === 'light',
};

const updateDOM = (isLight) => {
  if (isLight) {
    document.documentElement.setAttribute('data-theme', 'light');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.isLight = !state.isLight;
      localStorage.setItem('theme', state.isLight ? 'light' : 'dark');
      updateDOM(state.isLight);
    },
    setTheme: (state, action) => {
      state.isLight = action.payload;
      localStorage.setItem('theme', state.isLight ? 'light' : 'dark');
      updateDOM(state.isLight);
    },
    initTheme: (state) => {
      const isLight = localStorage.getItem('theme') === 'light';
      state.isLight = isLight;
      updateDOM(isLight);
    },
  },
});

export const { toggleTheme, setTheme, initTheme } = themeSlice.actions;
export default themeSlice.reducer;
